// The listeners a popover adds to things that outlive it: `document` (the desktop drag of a
// bottom sheet) and the page's scroll container (repositioning while scrolling). Each one is
// added through `listen`, which records how to take it off again, and `releaseAll` takes them
// all off when the popover is removed. Before this, nothing removed them, so every popover
// ever opened stayed reachable from `document`, and every scroll ran one reposition pass per
// popover the session had opened (df-c7f628e29b52).
//
// Removal is explicit rather than through an AbortController `signal`, because the `signal`
// option of addEventListener needs Chrome 90 or newer in the Android WebView.
export class PopoverListeners {
  private removals: (() => void)[] = [];

  listen<K extends keyof DocumentEventMap>(target: Document, type: K, handler: (event: DocumentEventMap[K]) => void): void;
  listen(target: EventTarget, type: string, handler: (event: Event) => void): void;
  listen(target: EventTarget, type: string, handler: (event: Event) => void): void {
    target.addEventListener(type, handler);
    this.removals.push(() => target.removeEventListener(type, handler));
  }

  // safe to call more than once: a listener is only ever removed once
  releaseAll(): void {
    const removals = this.removals;
    this.removals = [];
    for (const remove of removals) {
      remove();
    }
  }
}
